import {ChangeDetectionStrategy, Component, Input} from '@angular/core'
import {IndustriesAndOfferings} from '../pro-directory-page.types'
import {LinkService} from '../../../../core/i18n/link.service'
import {PUBLIC_ROUTES} from '../../../../shared/routing/public.routes'
import {Item} from '../../../../craft/holy-grail-grid/holy-grail-grid-sidenav/sidenav.types'

@Component({
  selector: 'bgo-sidenav-industries',
  templateUrl: './sidenav-industries.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: [
    `
      :host {
        display: block;
      }
    `,
  ],
  standalone: false,
})
export class SidenavIndustriesComponent {
  items: Item[] = []

  @Input() set industries(value: IndustriesAndOfferings[] | null) {
    this.items =
      value?.map(i => ({
        label: i.label,
        path: this.linkService.localizedPathTo(PUBLIC_ROUTES.INDUSTRY_OVERVIEW_PAGE, {
          routeParams: {pageSlug: i.overviewPage.slug},
        }),
      })) ?? []
  }

  constructor(protected readonly linkService: LinkService) {}
}
